// extracted by mini-css-extract-plugin
module.exports = {"dot":"ShopStatusDot_dot__1M96H","off":"ShopStatusDot_off__2lFhJ"};